import React, { useEffect } from 'react';
import useToggle from '@hooks/useToggle';
import domain from '../../domain';

export const showBatchAddTip = domain.event();

export function BatchAddTip() {
  const { isOn, on, off } = useToggle(false);
  useEffect(() => {
    let id: NodeJS.Timeout;
    const unwatch = showBatchAddTip.watch(() => {
      on();
      if (id) clearTimeout(id);
      id = setTimeout(() => {
        off();
      }, 3000);
    });
    return () => {
      unwatch();
      if (id) clearTimeout(id);
      off();
    };
  }, []);

  if (!isOn) return null;
  return (
    <div className="absolute mb-200 flex h-35 select-none items-center rounded bg-orange px-10 text-white">
      拖动标记点到相应位置
    </div>
  );
}
